export const SIDEBAR_WIDTH = 264;
export const SIDEBAR_WIDTH_COLLAPSED = 76;
export const TOPBAR_HEIGHT = 64;

/** Keep in sync with the width transitions in NavMenu.scss. */
export const SIDEBAR_TRANSITION_MS = 200;

export const SIDEBAR_COLLAPSED_STORAGE_KEY = "NAV_SIDEBAR_COLLAPSED";
